var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBarChart(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.929 1.5v20.25a.75.75 0 0 0 .75.75h20.25",
    stroke: "#5B5959",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.741 10.5H5.866a.937.937 0 0 0-.937.938v7.124c0 .518.42.938.937.938h1.875c.518 0 .938-.42.938-.937v-7.125a.937.937 0 0 0-.938-.938m6.75-2.25h-1.875a.937.937 0 0 0-.937.938v9.375c0 .517.42.937.937.937h1.875c.518 0 .938-.42.938-.937V9.188a.937.937 0 0 0-.938-.938m6.733-3H19.35a.94.94 0 0 0-.937.938v12.375c0 .517.42.937.937.937h1.875c.518 0 .938-.42.938-.937V6.188a.937.937 0 0 0-.938-.938",
    fill: "#8F8B8B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBarChart);
export default __webpack_public_path__ + "static/media/bar-chart.2396fd8e25b8f9ce21bc0c80d699c6b4.svg";
export { ForwardRef as ReactComponent };